__turbopack_context__.v({
  "appearance": "Modal-module__FD1w3a__appearance",
  "appearanceExit": "Modal-module__FD1w3a__appearanceExit",
  "appearanceOut": "Modal-module__FD1w3a__appearanceOut",
  "glass": "Modal-module__FD1w3a__glass",
  "panel": "Modal-module__FD1w3a__panel",
  "panelExit": "Modal-module__FD1w3a__panelExit",
  "panelIn": "Modal-module__FD1w3a__panelIn",
  "panelOut": "Modal-module__FD1w3a__panelOut",
  "payment-modal-background": "Modal-module__FD1w3a__payment-modal-background",
  "payment-modal-close-button": "Modal-module__FD1w3a__payment-modal-close-button",
  "payment-modal-content": "Modal-module__FD1w3a__payment-modal-content",
});
